import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_NEWS_REQUEST = 'News/FETCH_NEWS_REQUEST'
const FETCH_NEWS_SUCCESS = 'News/FETCH_NEWS_SUCCESS'
const FETCH_NEWS_FAILURE = 'News/FETCH_NEWS_FAILURE'

const CREATE_NEWS_REQUEST = 'News/CREATE_NEWS_REQUEST'
const CREATE_NEWS_SUCCESS = 'News/CREATE_NEWS_SUCCESS'
const CREATE_NEWS_FAILURE = 'News/CREATE_NEWS_FAILURE'

const UPDATE_NEWS_REQUEST = 'News/UPDATE_NEWS_REQUEST'
const UPDATE_NEWS_SUCCESS = 'News/UPDATE_NEWS_SUCCESS'
const UPDATE_NEWS_FAILURE = 'News/UPDATE_NEWS_FAILURE'

const DELETE_NEWS_REQUEST = 'News/DELETE_NEWS_REQUEST'
const DELETE_NEWS_SUCCESS = 'News/DELETE_NEWS_SUCCESS'
const DELETE_NEWS_FAILURE = 'News/DELETE_NEWS_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  newsList: [],
}

// Default Reducer
const news = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newsList: action.payload
      }
    case FETCH_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default news

// Action Creators
export const fetchNewsList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_NEWS_REQUEST
      })

      const response = await API.get(EndPoints.NEWS+ `/getAll`)
      dispatch({
        type: FETCH_NEWS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_NEWS_FAILURE
      })
    }
  }
}

export const createNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_NEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.NEWS+ `/createNews`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_NEWS_FAILURE
      })
    }
  }
}

export const updateNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_NEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.NEWS+ `/updateNews`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_NEWS_FAILURE
      })
    }
  }
}

export const deleteNews = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_NEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.NEWS + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_NEWS_FAILURE
      })
    }
  }
}






